export const globalConstants = {
    SET_SAVE_STATUS:'SET_SAVE_STATUS',
    SET_HEADER_HEIGHT:'SET_HEADER_HEIGHT',
    SET_BREADCRUMB_HEIGHT:'SET_BREADCRUMB_HEIGHT',
    SET_IS_LOADING:'SET_IS_LOADING',
    SHOW_MENU:'SHOW_MENU',
}